export const ORDER_STATUS_TITLE = 'Order status';
export const ENGINEER_VISIT_TITLE = `Today’s appointment`;

export enum TodaysApptUserFlowSteps {
  Init = 0,
  HalfAnHourBefore = 1,
  EndOfScheduledTimeSlot = 2,
  EndOfScheduledTimeSlotSuccess = 3,
}
